module.exports = __webpack_public_path__ + "static/media/18_before.89df9811.jpg";